var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAiOutput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 918,
    height: 750,
    viewBox: "0 0 918 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Results"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M31.5264 343.896V351.652",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M14.1064 348.096L20.4442 354.62",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M6.69434 365.464H15.6559",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M13.3799 383.14L19.7177 376.616",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M31.5264 385.261V377.505",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 10",
    d: "M44.4534 380.09L39.2827 374.919",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M54.7951 367.163H47.0391",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    d: "M49.6243 349.066L44.4536 354.236",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M447.766 5.21558V10.3863",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M432.255 20.7275H437.426",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M447.766 36.24V31.0693",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M460.693 20.7275H455.522",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M147.867 222.385V230.141",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M124.598 245.652H132.354",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M147.867 266.335V258.579",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M168.549 245.652H160.793",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    d: "M704.371 504.288C710.549 504.288 715.56 509.3 715.56 515.48C715.56 521.662 710.549 526.672 704.371 526.672C698.192 526.672 693.182 521.662 693.182 515.48",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M755.578 402.747C762.222 400.674 772.406 392.549 774.763 383.807C776.901 391.535 785.863 400.674 793.948 401.366C784.846 404.588 776.144 414.163 774.763 421.684C773.824 414.018 761.787 403.864 755.578 402.747Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5938 500.84C76.9167 499.803 82.0066 495.742 83.1852 491.371C84.2541 495.233 88.7338 499.803 92.7767 500.15C88.2268 501.76 83.8766 506.548 83.1852 510.309C82.7155 506.475 76.6973 501.397 73.5938 500.84Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.261 141.197C135.261 145.992 131.376 149.876 126.584 149.876C121.791 149.876 117.908 145.992 117.908 141.197C117.908 136.404 121.791 132.519 126.584 132.519C131.376 132.519 135.261 136.404 135.261 141.197Z",
    fill: "#D1D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M714.622 164.5C714.622 172.511 708.128 179.005 700.121 179.005C692.11 179.005 685.617 172.511 685.617 164.5C685.617 156.489 692.11 149.995 700.121 149.995C708.128 149.995 714.622 156.489 714.622 164.5Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M915.49 125.2C915.49 131.556 910.34 136.706 903.989 136.706C897.634 136.706 892.485 131.556 892.485 125.2C892.485 118.844 897.634 113.694 903.989 113.694C910.34 113.694 915.49 118.844 915.49 125.2Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.411 662.584C297.411 666.591 294.165 669.838 290.159 669.838C286.156 669.838 282.91 666.591 282.91 662.584C282.91 658.578 286.156 655.331 290.159 655.331C294.165 655.331 297.411 658.578 297.411 662.584Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.098 85.4429C293.098 90.2377 289.213 94.1214 284.421 94.1214C279.63 94.1214 275.745 90.2377 275.745 85.4429C275.745 80.6503 279.63 76.7644 284.421 76.7644C289.213 76.7644 293.098 80.6503 293.098 85.4429Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.41 742.907C508.866 745.017 502.661 742.231 500.552 736.687C498.443 731.142 501.226 724.933 506.772 722.826C512.314 720.716 518.519 723.5 520.628 729.045C522.74 734.591 519.955 740.797 514.41 742.907Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.104 537.795H299.094C284.172 537.795 271.957 525.544 271.957 510.572V208.235C271.957 193.263 284.172 181.018 299.094 181.018H511.104C526.032 181.018 538.247 193.263 538.247 208.235V510.572C538.247 525.544 526.032 537.795 511.104 537.795Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.006 550.722H280.996C266.074 550.722 253.859 538.472 253.859 523.499V221.162C253.859 206.19 266.074 193.945 280.996 193.945H493.006C507.934 193.945 520.149 206.19 520.149 221.162V523.499C520.149 538.472 507.934 550.722 493.006 550.722Z",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.404 560.926H262.955C248.002 560.926 235.762 548.726 235.762 533.816V232.731C235.762 217.821 248.002 205.627 262.955 205.627H475.404C490.363 205.627 502.603 217.821 502.603 232.731V533.816C502.603 548.726 490.363 560.926 475.404 560.926Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.404 560.926H262.955C248.002 560.926 235.762 548.726 235.762 533.816V232.731C235.762 217.821 248.002 205.627 262.955 205.627H475.404C490.363 205.627 502.603 217.821 502.603 232.731V533.816C502.603 548.726 490.363 560.926 475.404 560.926Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.78 297.359H287.861C283.38 297.359 279.712 293.869 279.712 289.606C279.712 285.337 283.38 281.847 287.861 281.847H444.78C449.262 281.847 452.93 285.337 452.93 289.606C452.93 293.869 449.262 297.359 444.78 297.359Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.78 343.895H287.861C283.38 343.895 279.712 340.405 279.712 336.142C279.712 331.873 283.38 328.383 287.861 328.383H444.78C449.262 328.383 452.93 331.873 452.93 336.142C452.93 340.405 449.262 343.895 444.78 343.895Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.78 390.431H287.861C283.38 390.431 279.712 386.941 279.712 382.678C279.712 378.414 283.38 374.919 287.861 374.919H444.78C449.262 374.919 452.93 378.414 452.93 382.678C452.93 386.941 449.262 390.431 444.78 390.431Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.78 436.967H287.861C283.38 436.967 279.712 433.478 279.712 429.214C279.712 424.945 283.38 421.455 287.861 421.455H444.78C449.262 421.455 452.93 424.945 452.93 429.214C452.93 433.478 449.262 436.967 444.78 436.967Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.771 483.503H287.896C283.396 483.503 279.712 480.013 279.712 475.75C279.712 471.481 283.396 467.991 287.896 467.991H369.771C374.271 467.991 377.955 471.481 377.955 475.75C377.955 480.013 374.271 483.503 369.771 483.503Z",
    fill: "#E0E2EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.027 423.36C503.649 454.732 455.073 458.271 419.807 434.049C415.3 430.898 411.01 427.359 407.01 423.36C404.951 421.307 403.01 419.189 401.181 416.959C397.523 412.505 394.318 407.756 391.693 402.848C387.068 394.56 383.923 385.764 382.206 376.673C376.666 348.162 384.949 317.474 407.01 295.424C429.124 273.307 459.817 265.078 488.332 270.564C497.419 272.334 506.222 275.478 514.512 280.05C519.427 282.734 524.112 285.938 528.573 289.595C530.796 291.418 532.915 293.365 534.968 295.424C538.975 299.423 542.567 303.706 545.659 308.219C569.892 343.472 566.345 392.047 535.027 423.36Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.247 417.181C493.603 449.831 440.701 449.825 408.051 417.181C375.443 384.573 375.443 331.665 408.094 299.021C440.701 266.413 493.603 266.413 526.211 299.021C558.855 331.665 558.855 384.573 526.247 417.181ZM543.001 282.248C501.099 240.347 433.199 240.347 391.298 282.248C349.402 324.144 349.366 392.087 391.261 433.988C429.397 472.111 489.169 475.549 531.21 444.248C535.317 441.186 539.271 437.754 543.043 433.988C546.809 430.216 550.241 426.261 553.297 422.155C584.598 380.108 581.13 320.378 543.001 282.248Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M707.901 591.936L706.142 593.696C694.504 605.34 675.446 605.34 663.802 593.696L556.343 486.236L600.442 442.137L707.901 549.597C719.545 561.241 719.545 580.292 707.901 591.936Z",
    fill: "url(#paint0_linear_509_39718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.613 418.87L587.368 450.624L564.824 473.162L533.076 441.407C537.266 438.283 541.295 434.781 545.15 430.938C548.993 427.095 552.495 423.06 555.613 418.87Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.294 548.275L662.476 592.088L654.587 584.193L698.4 540.381L706.294 548.275Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M602.881 443.655L557.862 488.674L551.174 481.986L596.192 436.967L602.881 443.655Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.637 287.79L394.234 398.187C390.076 390.735 387.249 382.828 385.711 374.655L481.103 279.261C489.271 280.858 497.185 283.679 504.637 287.79Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.832 314.03L421.474 426.626C417.2 423.812 413.132 420.645 409.338 417.066C407.385 415.223 405.538 413.334 403.809 411.338L524.621 297.359C526.736 298.995 528.745 300.738 530.692 302.58C534.486 306.16 537.899 309.992 540.832 314.03Z",
    fill: "white",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_509_39718",
    x1: 636.489,
    y1: 361.992,
    x2: 476.198,
    y2: 522.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAiOutput);
export default __webpack_public_path__ + "static/media/EmptyAiOutput.aa52a2369fa48b3b5a46c6c7e6889b9e.svg";
export { ForwardRef as ReactComponent };